<template>
    <div>
        <div v-if="show===0">
            <div v-if="user.role == 4">
                <v-menu
                        offset-y
                        origin="center center"
                        :nudge-bottom="10"
                        transition="scale-transition"
                >
                    <v-btn class="yoprimary" dark :title="$t('lang.class.createQuiz')" slot="activator" round>
                        <v-icon dark>add</v-icon>
                        &nbsp;Tạo bài tập
                    </v-btn>

                    <v-list two-line class="pa-0">
                        <template>
                            <div class="notify" @click="createQuizQuestion">Bài tâp trắc nghiệm</div>
                            <div class="notify" @click="createEssayQuestion">Bài tâp tự luận</div>
                        </template>
                    </v-list>
                </v-menu>
                <v-btn color="info" @click="createMatrix" round>
                    <v-icon dark>add</v-icon>
                    &nbsp;Tạo ma trận
                </v-btn>

                <!--
                <v-btn class="yoprimary" dark @click="createQuizQuestion" :title="$t('lang.class.createQuiz')">
                    <v-icon dark>list_alt</v-icon>
                    &nbsp;Tạo bài tập trắc nghiệm
                </v-btn>
                <v-btn class="orange" dark @click="createEssayQuestion" :title="$t('lang.class.createEssay')">
                    <v-icon dark>notes</v-icon>
                    &nbsp;Tạo bài tập tự luận
                </v-btn>
-->
            </div>
            <v-tabs v-model="selectedTab" style="background-color: #00a650" dark>
                <v-tab key="sentExercise" @click="getPost"
                       v-if="$store.state.auth.user.role == 1 || $store.state.auth.user.role == 4">
                    Bài tập đã giao
                </v-tab>
                <v-tab key="unsentExercise" @click="getUnsentPost"
                       v-if="$store.state.auth.user.role == 1 || $store.state.auth.user.role == 4">
                    Bài tập chưa giao
                </v-tab>
                <v-tab key="unComplete" @click="getUnsentPost" v-if="$store.state.auth.user.role == 2">
                    Bài tập chưa nộp
                </v-tab>
                <v-tab key="completed" @click="getPost" v-if="$store.state.auth.user.role == 2">
                    Bài tập đã nộp
                </v-tab>
                <v-tabs-items :touchless="true">
                    <v-tab-item key="sentExercise"
                                v-if="$store.state.auth.user.role == 1 || $store.state.auth.user.role == 4">
                        <table style="width: 100%;background-color: white;border-collapse: collapse;" class="lstTable">
                            <tr :item="item" v-for="item in posts" style="border-bottom:1px solid #eadede">
                                <td width="10%" style="text-align: center;">
                                    <img src="../../../public/img/yolearn_logo.png" width="30px" v-if="item.source==1"/>
                                    <img src="../../../public/img/logo_green.png" width="30px" v-else/>
                                </td>
                                <td width="50%" style="padding: 10px">
                                    <div class="primaryColor title" style="margin-top: 10px;margin-bottom: 10px">
                                        {{item.title}}
                                    </div>
                                    <div>Ngày cập nhật: {{item.createdAt | formatDateTime}}</div>
                                    <div>Ngày hết hạn: {{item.dueDate | formatDate}} <label
                                            v-html="getRemainTime(item.dueDate)"></label></div>
                                    <div>Hình thức: {{getExerciseType(item.objectType)}} <label
                                            v-if="item.objectType==6">:{{item.numberOfQuiz}}
                                        câu</label></div>
                                </td>
                                <td width="20%">
                                    <div>Đã giao: {{getNumberOfReceiver(item)}}</div>
                                    <div>Đã làm: {{getNumberOfComplete(item)}}</div>
                                </td>
                                <td width="20%">
                                    <v-btn flat dark color="primary" @click="onView(item)">
                                        <v-icon>visibility</v-icon>
                                        Xem bài tập
                                    </v-btn>
                                    <v-btn flat dark color="primary" @click="onView(item,null,true)">
                                        <v-icon>timeline</v-icon>
                                        Xem báo cáo
                                    </v-btn>
                                </td>
                            </tr>
                        </table>
                        <!--post :item="item" v-for="item in posts" :class-id="classId" @edit="onEdit" @view="onView"
                              @reload="onReload"/-->
                        <div v-if="posts.length == postCount"
                             style="font-weight: bold;text-align: center;padding-top: 10px;color:white">
                            Không có thêm bài tập nào
                        </div>
                        <v-progress-linear
                                indeterminate
                                color="pink"
                                v-else-if="posts.length < postCount"
                        ></v-progress-linear>

                    </v-tab-item>
                    <v-tab-item key="unsentExercise"
                                v-if="$store.state.auth.user.role == 1 || $store.state.auth.user.role == 4">
                        <table style="width: 100%;background-color: white;border-collapse: collapse;" class="lstTable">
                            <tr :item="item" v-for="item in notSendPost" style="border-bottom:1px solid #eadede">
                                <td width="10%" style="text-align: center;">
                                    <img src="../../../public/img/yolearn_logo.png" width="30px" v-if="item.source==1"/>
                                    <img src="../../../public/img/logo_green.png" width="30px" v-else/>
                                </td>
                                <td width="70%" style="padding: 10px">
                                    <div class="primaryColor title" style="margin-top: 10px;margin-bottom: 10px">
                                        {{item.title}}
                                    </div>
                                    <div>Ngày cập nhật: {{item.createdAt | formatDateTime}}</div>
                                    <div>Hình thức: {{getExerciseType(item.objectType)}}</div>
                                </td>
                                <td width="20%">
                                    <v-btn flat dark color="primary" @click="onEdit(item)">
                                        <v-icon>send</v-icon>
                                        Giao bài tập
                                    </v-btn>
                                </td>
                            </tr>
                        </table>
                        <!--post :item="item" v-for="item in posts" :class-id="classId" @edit="onEdit" @view="onView"
                              @reload="onReload"/-->
                        <div v-if="notSendPost.length == notSendPostCount"
                             style="font-weight: bold;text-align: center;padding-top: 10px;color:white">
                            Không có thêm bài tập nào
                        </div>
                        <v-progress-linear
                                indeterminate
                                color="pink"
                                v-else-if="posts.length < postCount"
                        ></v-progress-linear>
                    </v-tab-item>
                    <v-tab-item key="unComplete" v-if="$store.state.auth.user.role == 2">
                        <table style="width: 100%;background-color: white;border-collapse: collapse;" class="lstTable">
                            <tr :item="item" v-for="item in notSendPost" style="border-bottom:1px solid #eadede">
                                <td width="10%" style="text-align: center;">
                                    <img src="../../../public/img/yolearn_logo.png" width="30px" v-if="item.source==1"/>
                                    <img src="../../../public/img/logo_green.png" width="30px" v-else/>
                                </td>
                                <td width="40%" style="padding: 10px">
                                    <div class="primaryColor title" style="margin-top: 10px;margin-bottom: 10px">
                                        {{item.title}}
                                    </div>
                                    <div>Ngày hết hạn: {{item.dueDate | formatDate}} <label
                                            v-html="getRemainTime(item.dueDate)"></label></div>
                                    <div>Hình thức: {{getExerciseType(item.objectType)}}
                                        <label
                                                v-if="item.objectType==6">:{{item.numberOfQuiz}}
                                            câu</label>
                                    </div>
                                </td>
                                <td width="30%">
                                    <div v-if="item.questionTime != null && item.questionTime>0">
                                        <div class="primaryColor">Thời gian:
                                            {{item.questionTime}} phút
                                        </div>
                                        <div v-if="item.status==1 || item.status==0" style="color: red"
                                             :key="item.postId+'_'+item.remainTime">Thời gian còn lại:
                                            {{item.remainTime}}
                                        </div>
                                    </div>
                                </td>
                                <td width="20%">
                                    <v-btn flat dark color="primary" @click="onView(item)">
                                        <v-icon v-if="isExpire(item.dueDate)">visibility</v-icon>
                                        <v-icon v-else>edit</v-icon>
                                        <label v-if="isExpire(item.dueDate)">Xem bài tập</label>
                                        <label v-else-if="item.status==1 || item.status == 0">Tiếp tục làm bài
                                            tập</label>
                                        <label v-else>Làm bài tập</label>
                                    </v-btn>
                                </td>
                            </tr>
                        </table>
                        <!--post :item="item" v-for="item in posts" :class-id="classId" @edit="onEdit" @view="onView"
                              @reload="onReload"/-->
                        <div v-if="notSendPost.length == notSendPostCount"
                             style="font-weight: bold;text-align: center;padding-top: 10px;color:white">
                            Không có thêm bài tập nào
                        </div>
                        <v-progress-linear
                                indeterminate
                                color="pink"
                                v-else-if="posts.length < postCount"
                        ></v-progress-linear>

                    </v-tab-item>
                    <v-tab-item key="completed" v-if="$store.state.auth.user.role == 2">
                        <table style="width: 100%;background-color: white;border-collapse: collapse;" class="lstTable">
                            <tr :item="item" v-for="item in posts" style="border-bottom:1px solid #eadede">
                                <td width="10%" style="text-align: center;">
                                    <img src="../../../public/img/yolearn_logo.png" width="30px" v-if="item.source==1"/>
                                    <img src="../../../public/img/logo_green.png" width="30px" v-else/>
                                </td>
                                <td width="40%" style="padding: 10px">
                                    <div class="primaryColor title" style="margin-top: 10px;margin-bottom: 10px">
                                        {{item.title}}
                                    </div>
                                    <div>Ngày hết hạn: {{item.dueDate | formatDate}}
                                        <label v-html="getRemainTimeNoExpire(item.dueDate)"></label></div>
                                    <div>Ngày nộp bài: {{item.endTime | formatDateTime}}</div>
                                    <div>Hình thức: {{getExerciseType(item.objectType)}}
                                        <label
                                                v-if="item.objectType==6">:{{item.numberOfQuiz}}
                                            câu</label>
                                    </div>
                                </td>
                                <td width="25%">
                                    <div class="primaryColor">Điểm: {{item.mark}}</div>
                                </td>
                                <td width="25%">
                                    <v-btn flat dark color="primary" @click="onView(item)">
                                        <v-icon>visibility</v-icon>
                                        Xem bài tập
                                    </v-btn>
                                    <v-btn flat dark color="primary" @click="onViewReport(item)">
                                        <v-icon>timeline</v-icon>
                                        Xem báo cáo
                                    </v-btn>
                                </td>
                            </tr>
                        </table>
                        <!--post :item="item" v-for="item in posts" :class-id="classId" @edit="onEdit" @view="onView"
                              @reload="onReload"/-->
                        <div v-if="posts.length == postCount"
                             style="font-weight: bold;text-align: center;padding-top: 10px;color:white">
                            Không có thêm bài tập nào
                        </div>
                        <v-progress-linear
                                indeterminate
                                color="pink"
                                v-else-if="posts.length < postCount"
                        ></v-progress-linear>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
            <!--post :item="item" v-for="item in posts" :class-id="classId" @edit="onEdit" @view="onView"
                  @reload="onReload"/>
            <div v-if="posts.length == postCount" style="font-weight: bold;text-align: center;padding-top: 10px">
                Không có thêm bài viết nào
            </div-->
            <!--
                        <button class="yoprimary" @click="loadMore" style="width: 100%;margin-left:0px;margin-bottom: 25px">
                            {{$t('lang.common.loadmore')}}
                        </button>
            -->
        </div>
        <div v-else-if="show === 1">
            <essay-create @onCancelCreate="showList" :class-id="classId" :question="essayQuestion"
                          style="margin:auto"/>
        </div>
        <div v-else-if="show === 2">
            <quiz-create @onCancelCreate="showList" :class-id="classId" :question="quizQuestion" :source="source"/>
        </div>
        <div v-else-if="show===3">
            <teacher-view-question :key="classId+'_0_'+ question.questionId" :student-id="studentId"
                                   @onEditQuestion="onViewQuestion"
                                   v-if="user.role == 1 || user.role == 4" @onCancelCreate="showList"
                                   :class-id="classId"
                                   :question="question" :object-type="questionType" ref="teacherView"/>
            <student-view-question :key="classId+'_1_'+ question.questionId" v-else-if="user.role == 2"
                                   @onCancelCreate="showList" :class-id="classId" :question="question"
                                   :object-type="questionType" ref="studentView"/>
        </div>
        <!--
                <div v-else>
                    <matrix-page :class-id="classId" @cancel="matrixCancel"/>
                </div>
        -->
    </div>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios";
    import ClazzCreate from "../class/createClass";
    import TeacherInfo from "../class/teacherProfile";
    import Post from "./post";
    import EssayCreate from "./essayQuestion";
    import QuizCreate from "./quizQuestion";
    import TeacherViewQuestion from "./teacherViewQuestion";
    import StudentViewQuestion from "./studentViewQuestion";
    import MatrixPage from "./matrix/matrixPage";
    import moment from "moment";

    export default {
        components: {
            MatrixPage,
            StudentViewQuestion, TeacherViewQuestion, QuizCreate, EssayCreate, Post, TeacherInfo, ClazzCreate
        },
        props: {
            objectType: {
                type: String | Number,
                default: 0
            },
            classId: {
                type: String | Number,
                default: null
            },

        },

        watch: {
            classId: function (data) {
                this.getPost();
            }
        },

        computed: {
            styleOfFeed: function () {
                if (this.editting) {
                    return "feed active";
                } else {
                    return "feed";
                }
            },

            backgroundStyle: function () {
                if (this.editting) {
                    return "background show";
                } else {
                    return "background";
                }
            }
        },

        data() {
            return {
                activeTab: 0,
                selectedTab: null,
                show: 0,
                cl: {},
                source: 0,
                question: {},
                questionType: null,
                essayQuestion: {},
                quizQuestion: {},
                postCount: 0,
                posts: [],
                notSendPostCount: 0,
                notSendPost: [],
                editingPost: {},
                media: [],
                user: {},
                content: "",
                title: "",
                postURL: null,
                postId: null,
                parentId: null,
                accept: "video/*,  video/x-m4v, video/webm, video/x-ms-wmv, video/x-msvideo, video/3gpp, video/flv, video/x-flv, video/mp4, video/quicktime, video/mpeg, video/ogv, .ts, .mkv, image/*, image/heic, image/heif",
                fileContent: null,
                fileURL: null,
                fileName: null,
                fileType: null,
                editting: false,
                studentId: null,
                page: 1,
                unsentPage: 1,
                pageSize: 10,
                search: null,
                interval: null
            }
        },

        created() {
            this.unsubscribe = this.$store.subscribe((mutation, state) => {
                if (mutation.type == "common/setSearch") {
                    this.search = mutation.payload;
                    this.getPost();
                }
            });

            this.user = this.$store.state.auth.user;
            if (this.$route.params.clzz) {
                this.cl = this.$route.params.clzz;
                //console.log("---exercise---");
                //console.log(this.cl);
            }
            /*
                        if(this.user.role == 1 || this.user.role == 4){
                            this.selectedTab = 0;
                        } else {
                            this.selectedTab = 2;
                        }
            */
            this.getPost();
            this.interval = setInterval(this.calculateRemainTime, 1000);

        },

        beforeDestroy() {
            this.unsubscribe();
        },

        methods: {
            calculateRemainTime: function () {
                for (let i = 0; i < this.notSendPost.length; i++) {
                    let item = this.notSendPost[i];
                    if (item.status >= 2) {
                        item.remainTime = "Đã kết thúc";
                    } else {
                        if (item.questionTime == null || item.questionTime == "") {
                            item.remainTime = "";
                        } else {
                            let now = new Date();
                            let start = new Date(item.startTime);
                            let questionTime = item.questionTime * 60;
                            let duration = questionTime - parseInt((now.getTime() - start.getTime()) / 1000);
                            if (duration < 0) {
                                item.remainTime = "Hết giờ";
                            } else {
                                let second = duration % 60;
                                duration = parseInt(duration / 60);
                                let minutes = duration % 60; //minutes instead of asMinutes
                                duration = parseInt(duration / 60);
                                let hours = duration % 24; //hours instead of asHours
                                item.remainTime = hours + "h:" + minutes + "m:" + second + "s";
                            }
                        }
                    }
                }

                let temp = [];
                for (let i = 0; i < this.notSendPost.length; i++) {
                    temp.push(this.notSendPost[i]);
                }
                this.notSendPost = temp;
                //console.log(this.notSendPost);
            },

            getNumberOfReceiver(item) {
                if (item.receivers == null || item.receivers == "") {
                    return ""
                } else {
                    return item.receivers.split(",").length;
                }
            },

            getNumberOfComplete(item) {
                if (item.numberOfComplete == null) {
                    item.numberOfComplete = 0;
                }
                return item.numberOfComplete;
            },

            isExpire(time) {
                time = time + "T23:59:59";
                //console.log(time);
                let now = new Date();
                let t = new Date(time);
                if (t.getTime() < now.getTime()) {
                    return true;
                } else {
                    return false;
                }

            },

            getRemainTimeNoExpire(time) {
                time = time + "T23:59:59";
                //console.log(time);
                let now = new Date();
                let t = new Date(time);
                if (t.getTime() < now.getTime()) {
                    return "";
                } else {
                    return "<label style='color:blue'>(" + moment(t).fromNow() + ")</label>";
                }
            },

            getRemainTime(time) {
                time = time + "T23:59:59";
                //console.log(time);
                let now = new Date();
                let t = new Date(time);
                if (t.getTime() < now.getTime()) {
                    return "<label style='color:red'>(Đã hết hạn)</label>";
                } else {
                    return "<label style='color:blue'>(" + moment(t).fromNow() + ")</label>";
                }
            },

            getExerciseType(type) {
                if (type == 5) {
                    return "Tự luận"
                } else if (type == 6) {
                    return "Trắc nghiệm";
                }
            },

            onEdit: function (item) {
                this.edittingPost = item;
                if (item.objectType == 5) {
                    axios.post(process.env.VUE_APP_API_URL + "/exercise/getEssay?questionId=" + item.objectId).then(
                        data => {
                            this.essayQuestion = data;
                            //console.log(this.essayQuestion);
                            this.show = 1;
                        },
                        error => {

                        }
                    )
                } else if (item.objectType == 6) {
                    axios.post(process.env.VUE_APP_API_URL + "/exercise/getQuiz?questionId=" + item.objectId).then(
                        data => {
                            this.quizQuestion = data;
                            this.show = 2;
                            this.source = 0;
                            //console.log(this.quizQuestion);
                        }
                    )

                }
            },

            onViewQuestion(question) {
                this.show = 0;
                //console.log(question);
                this.$nextTick(() => {
                    this.onEdit(this.edittingPost);
                })
            },

            onView: function (item, userId, report) {
                //console.log(item)
                //console.log(userId);
                if (item.status == null || item.status == undefined) {
                    let cf = confirm("Bạn có sẵn sàng làm bài tập không?");
                    if (!cf) {
                        return;
                    }
                }
                this.edittingPost = item;
                if (item.objectType == 5) {
                    axios.post(process.env.VUE_APP_API_URL + "/exercise/getEssay?questionId=" + item.objectId).then(
                        data => {
                            this.question = data;
                            console.log(this.question);
                            this.questionType = item.objectType;
                            this.show = 3;
                            //console.log(this.show);
                            if (userId != undefined && userId != null && userId != "") {
                                this.studentId = userId;
                            } else {
                                this.studentId = null;
                            }
                            //console.log(report);
                            if (report == true) {
                                this.$nextTick(
                                    () => {
                                        this.$refs.teacherView.activeReport();
                                    }
                                )
                            }
                        },
                        error => {
                            console.log(error);
                        }
                    )
                } else if (item.objectType == 6) {
                    axios.post(process.env.VUE_APP_API_URL + "/exercise/getQuiz?questionId=" + item.objectId).then(
                        data => {
                            this.question = data;
                            console.log(this.question);
                            this.questionType = item.objectType;
                            this.show = 3;
                            //console.log(this.show);
                            if (userId != undefined && userId != null && userId != "") {
                                this.studentId = userId;
                            } else {
                                this.studentId = null;
                            }
                            //console.log(report);
                            if (report == true) {
                                this.$nextTick(
                                    () => {
                                        this.$refs.teacherView.activeReport();
                                    }
                                )
                            }
                        },
                        error => {
                            console.log(error);

                        }
                    )

                }
            },

            onViewReport: function (item) {
                axios.post(process.env.VUE_APP_API_URL + "/report/getLessonReport?classId=" + this.classId + "&exerciseId=" + item.objectId + "&exerciseType=" + item.objectType).then(
                    data => {
                        if (data == null || data == "" || data.status != 2) {
                            message.error("Báo cáo chưa có");
                        } else {
                            this.$emit("report", data);
                        }
                    },
                    error => {
                        console.log(error);
                    }
                )
            },

            onReload: function () {
                this.getPost();
                this.getUnsentPost();
            },

            loadMore: function () {
                let page;
                let url;
                console.log(this.activeTab);
                if (this.activeTab == 0) {
                    page = Math.floor(this.posts.length / this.pageSize) + 1;
                    url = process.env.VUE_APP_API_URL + "/post/onSearchExercise?classId=" + this.classId + "&page=" + page + "&pageSize=" + this.pageSize;
                } else {
                    page = Math.floor(this.notSendPost.length / this.pageSize) + 1;
                    url = process.env.VUE_APP_API_URL + "/post/onSearchUnsentExercise?classId=" + this.classId + "&page=" + page + "&pageSize=" + this.pageSize;
                }
                if (this.search != null && this.search != "") {
                    url += "&search=" + this.search;
                }
                axios.post(url).then(
                    data => {
                        if (this.activeTab == 0) {
                            this.postCount = data.count;
                            for (let i = 0; i < data.items.length; i++) {
                                let bDuplicate = false;
                                for (let j = this.posts.length - 1; j >= 0; j--) {
                                    if (data.items[i].postId == this.posts[j].postId) {
                                        bDuplicate = true;
                                        break;
                                    }
                                }
                                if (!bDuplicate) {
                                    this.posts.push(data.items[i]);
                                }
                            }
                        } else {
                            this.notSendPostCount = data.count;
                            for (let i = 0; i < data.items.length; i++) {
                                let bDuplicate = false;
                                for (let j = this.notSendPost.length - 1; j >= 0; j--) {
                                    if (data.items[i].postId == this.notSendPost[j].postId) {
                                        bDuplicate = true;
                                        break;
                                    }
                                }
                                if (!bDuplicate) {
                                    this.notSendPost.push(data.items[i]);
                                }
                            }

                        }
                    },
                    error => {

                    }
                )
            },

            getPost: function () {
                this.activeTab = 0;
                let url = process.env.VUE_APP_API_URL + "/post/onSearchExercise?classId=" + this.classId + "&page=" + this.page + "&pageSize=" + this.pageSize;
                if (this.search != null && this.search != "") {
                    url += "&search=" + this.search;
                }
                axios.post(url).then(
                    data => {
                        this.postCount = data.count;
                        this.posts = data.items;
                        //console.log(this.posts);
                    },
                    error => {

                    }
                )
            },

            getUnsentPost: function () {
                this.activeTab = 1;
                let url = process.env.VUE_APP_API_URL + "/post/onSearchUnsentExercise?classId=" + this.classId + "&page=" + this.page + "&pageSize=" + this.pageSize;
                if (this.search != null && this.search != "") {
                    url += "&search=" + this.search;
                }
                axios.post(url).then(
                    data => {
                        this.notSendPostCount = data.count;
                        this.notSendPost = data.items;
                        //console.log(this.posts);
                    },
                    error => {

                    }
                )
            },

            showList: function () {
                this.show = 0;
                if (this.activeTab == 0) {
                    if (this.$store.state.auth.user.role == 2) {
                        this.getUnsentPost();
                    } else {
                        this.getPost();
                    }
                } else {
                    if (this.$store.state.auth.user.role == 2) {
                        this.getPost();
                    } else {
                        this.getUnsentPost();
                    }
                }
            },

            createEssayQuestion: function () {
                console.log(this.show);
                this.essayQuestion = null;
                this.show = 1;
                console.log(this.show);
            },

            createQuizQuestion: function () {
                console.log(this.show);
                this.quizQuestion = null;
                this.show = 2;
                this.source = 0;
                console.log(this.show);
            },

            createMatrix: function () {
                this.quizQuestion = null;
                this.show = 2;
                this.source = 3;
            },

            matrixCancel: function () {
                this.showList();
            }
        }
    };
</script>